<template>
  <section>
    <div id="zakaz" class="pd70">
      <div class="wrapper w1200">
        <div class="action_box">
          <UiAnim tag="h2" type="rl-100">Акции</UiAnim>
          <ul>
            <UiAnim
              tag="li"
              type="rl-100"
              v-for="(a, i) in actions"
              :key="i"
              :delay="i"
            >
              <UiAnim tag="span" type="t-30" :class="`icon icon-${a.icon}`" />
              <UiAnim tag="h3" type="t-30"> {{ a.title }} </UiAnim
              ><UiAnim tag="p" type="t-30">
                {{ a.text }}
              </UiAnim>
            </UiAnim>
          </ul>
        </div>

        <div class="zakaz_box">
          <UiAnim tag="h2" type="lr-100">Оставьте заявку</UiAnim>

          <UiAnim class="zakaz_form form" type="lr-100">
            <p>и мы свяжемся с вами в течение 15 минут.</p>

            <form @submit.prevent="submit">
              <div class="form-loader" v-if="loading">
                <IconLoader />
              </div>
              <UiAnim type="t-30" class="from-field">
                <input
                  type="text"
                  v-model="form.name.value"
                  placeholder="Имя *"
                  required
                  maxlength="50"
                  :class="{ error: form.name.classError }"
                  @focus="form.name.focus"
                  @blur="form.name.blur"
                />
                <p v-if="form.name.showError" class="error">
                  Минимальня длина поля "Имя" 3 символа
                </p>
              </UiAnim>
              <UiAnim type="t-30" class="from-field">
                <input
                  type="tel"
                  v-model="form.phone.value"
                  placeholder="Номер телефона *"
                  required
                  @input="checkPhoneInput"
                  maxlength="18"
                  :class="{ error: form.phone.classError }"
                  @focus="form.phone.focus"
                  @blur="form.phone.blur"
                />
                <p v-if="form.phone.showError" class="error">
                  Введите номер телефона в международном формате
                </p></UiAnim
              >
              <UiAnim type="t-30" class="from-field">
                <input
                  type="email"
                  placeholder="E-mail"
                  v-model="form.email.value"
                  :class="{ error: form.email.classError }"
                  @focus="form.email.focus"
                  @blur="form.email.blur"
                />
                <p v-if="form.email.showError" class="error">
                  Введите корректный E-mail
                </p></UiAnim
              >
              <UiAnim type="t-30">
                <button
                  type="submit"
                  :class="{ disabled: loading || !form.valid || !accept }"
                >
                  Отправить
                </button></UiAnim
              >
            </form>
            <UiAnim type="t-30">
              <UiConditionsLink v-model="accept" />
            </UiAnim>
          </UiAnim>
        </div>

        <span class="clr"></span>
      </div>
    </div>
  </section>
  <Teleport to="body">
    <UiAlert v-if="alert" @closed="alert = null" :text="alert" />
  </Teleport>
</template>

<script setup>
const actions = [
  {
    title: "Бесплатная регулировка фар",
    text: "правильное направление светового потока на полотно проезжей части и края обочины",
    icon: "tune",
  },
  {
    title: "Скидка 30% на бронирование фар",
    text: "защитный слой, который предотвращает повреждение поверхности от ударов камней во время движения",
    icon: "discount",
  },
  {
    title: "Полировка входит в комплекс услуг",
    text: "придаст вашему автомобилю обновлённый вид, обезопасит ваше зрение и снизит вероятность аварий",
    icon: "fabric-sample",
  },
];
import { maskInp } from "~/helpers/format";
import { useForm, form2Body, clearForm } from "~/helpers/form";
import { minLength, checkEmail, required } from "~/helpers/validators";
const loading = ref();
const alert = ref();
const accept = ref(false);

const form = useForm({
  name: {
    value: "",
    validators: { required, minLength: minLength(3) },
  },
  phone: {
    value: "",
    validators: { required, minLength: minLength(18) },
  },
  email: {
    value: "",
    validators: { checkEmail },
  },
});

const checkPhoneInput = () => {
  form.phone.value = maskInp(form.phone.value);
};

const submit = async () => {
  if (!form.valid || loading.value || !accept.value) return;
  useMetrika("form");
  loading.value = true;
  const res = await $fetch("/api/submit", {
    method: "POST",
    body: form2Body(form, "zakaz"),
  });
  loading.value = false;
  accept.value = false;
  clearForm(form);
  if (res?.success) {
    alert.value =
      "Ваша заявка отправлена. Мы свяжемся с Вами в течение 15 минут.";
  } else alert.value = -1;
};
</script>
